module.exports = __webpack_public_path__ + "static/media/logo__0005_MonteCarlo.7f81c878.png";